import React from 'react';
import { TriangleAlert, OctagonAlert, Clock, PackageX, PackageMinus, Settings } from 'lucide-react';

/** Severity → label, StatusTag tone and the accent bar shown on unread items. */
export const getSeverityConfig = (severity) => {
    switch (severity) {
        case 'critical':
            return { tone: 'danger', accent: 'bg-danger-solid', icon: <OctagonAlert />, text: 'Crítica' };
        case 'high':
            return { tone: 'danger', accent: 'bg-danger-border', icon: <TriangleAlert />, text: 'Alta' };
        case 'medium':
            return { tone: 'warning', accent: 'bg-warning-solid', icon: <Clock />, text: 'Media' };
        case 'low':
            return { tone: 'info', accent: 'bg-info-solid', icon: <Clock />, text: 'Baja' };
        default:
            return { tone: 'neutral', accent: 'bg-surface-300', icon: <Clock />, text: severity };
    }
};

/** Notification type → label, StatusTag tone and icon. */
export const getTypeConfig = (type) => {
    switch (type) {
        case 'quiebre_stock':
            return { tone: 'danger', dot: 'bg-danger-solid', text: 'Quiebre de Stock', icon: <PackageX /> };
        case 'low_inventory':
            return { tone: 'warning', dot: 'bg-warning-solid', text: 'Inventario Bajo', icon: <PackageMinus /> };
        case 'system':
            return { tone: 'brand', dot: 'bg-primary-600', text: 'Sistema', icon: <Settings /> };
        default:
            return { tone: 'neutral', dot: 'bg-surface-400', text: type, icon: <Clock /> };
    }
};
